import styled, { css } from 'styled-components';
import { ReactComponent as SortIcon } from './AZ.svg';
import { SortIconState } from '../../model';
import { Warning as WarningIcon } from 'features/shared/ui/sharedStyled';

const sectionDivider = css`
  border-right: 1px solid var(--black-20);
`;

const headerBottomBorder = css`
  border-bottom: 1px solid var(--black-20);
`;

export const TableWrap = styled.div`
  position: relative;
  overflow: auto;
  max-height: 353px;
  margin-bottom: 16px;
  border: 1px solid var(--black-20);
  border-radius: 16px;
`;

export const Td = styled.td<{ rowspan?: number; colspan?: number }>`
  border: none;
  padding: 16px;
  font-size: 16px;
  line-height: 22px;
`;

export const Th = styled.th`
  border: none;
  font-weight: bold;
  font-size: 14px !important;
  line-height: 20px !important;
  text-align: center;
  vertical-align: middle;
`;

export const Thead = styled.thead`
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;

  th,
  td {
    ${headerBottomBorder}
  }

  tr:first-child th[colspan] {
    border-bottom: none;
  }

  tr:first-child th[rowspan],
  tr:first-child td[rowspan] {
    border-bottom: none;
  }

  tr:last-child th,
  tr:last-child td {
    border-bottom: none;
  }

  td {
    padding: 0;
  }
`;

export const Tfoot = styled.tfoot`
  position: sticky;
  bottom: 0;
  background: white;
  font-weight: bold;
  max-height: 54px;
  z-index: 1;
`;

export const Tr = styled.tr``;

export const ThContent = styled.div`
  text-align: left;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
`;

export const SubheaderThContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  max-width: 100%;
  padding: 8px 6px;
  box-sizing: border-box;
  color: var(--black-60);
  font-size: 14px;
  line-height: 20px;
  text-align: center;

  svg {
    margin-left: 0;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }
`;

export const SubheaderText = styled.span`
  text-align: center;
  min-width: 0;
  flex: 0 1 auto;
`;

export const Tbody = styled.tbody`
  tr:first-child td {
    border-top: 1px solid var(--black-20);
  }

  ${Tr} {
    &:nth-child(even) {
      background: rgba(9, 21, 38, 0.07);
    }
  }
`;

export const TdWithNumbers = styled(Td)`
  text-align: center;
  span {
    color: rgba(9, 21, 38, 0.35);
  }
`;
const textCell = css`
  overflow: hidden;
  max-width: 0;

  > div {
    min-width: 0;
    width: 100%;
  }
`;

export const Municipality = styled(Td)`
  ${textCell}
`;
export const School = styled(Td)`
  ${textCell}
`;
export const Regisrations = styled(TdWithNumbers)``;
export const Participants = styled(TdWithNumbers)`
  vertical-align: middle;
`;
export const Winners = styled(TdWithNumbers)`
  vertical-align: middle;
`;

export const TotalLabel = styled(Td)`
  text-align: right;
  color: var(--primary-base);
  ${sectionDivider}
`;

export const Table = styled.table<{ $isRegionUser?: boolean }>`
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;

  thead ${School},
  tbody ${School} {
    ${sectionDivider}
  }

  ${({ $isRegionUser }) =>
    $isRegionUser &&
    css`
      thead ${Municipality},
      tbody ${Municipality} {
        ${sectionDivider}
      }
    `}
`;

export const Sort = styled(SortIcon)<{ state?: SortIconState }>`
  margin-left: 8px;
  cursor: pointer;

  path {
    fill: ${({ state }) =>
      state === SortIconState.ascending || state === SortIconState.descending
        ? 'var(--primary-base)'
        : 'var(--black-60)'};
    fill-opacity: 1;
    transition: fill 0.125s ease-in-out;
  }

  &:hover path {
    fill: var(--primary-base);
  }

  ${({ state }) =>
    state === SortIconState.descending &&
    css`
      transform: scale(1, -1);
    `}
`;

export const Warning = styled(WarningIcon)`
  margin-left: 8px;
`;
